

export class BasicSmartfoxConstants {
    public static S2C_NEW_LOGIN_SOCIAL: string = "core_spl";

    public static S2C_SPECIAL_OFFER_EVENT: string = "soe";
    public static S2C_SPECIAL_INGAME_OFFEREVENT: string = "sio";

    public static S2C_SERVER_MESSAGE: string = "sms";
    public static S2C_COMA_TEASER: string = "cmt";

    public static S2C_CASH_HASH: string = "gch";
    public static S2C_NEW_CASH_HASH: string = "nch";
    public static S2C_GET_FORUM_LOGIN_DATA: string = "gfl";

    public static S2C_SERVER_INFO_EVENT: string = "nfo";

    public static S2C_VERIFY_PLAYER_MAIL_EVENT: string = "vpm";
    public static S2C_LOST_PASSWORD_EVENT: string = "lpp";

    public static S2C_CHILD_PROTECTION_AUTO_SHUTDOWN_EVENT: string = "core_cps";

    public static S2C_SOCIAL_PLAYER_EXISTS: string = "core_spe";

    public static S2C_VERSION_CHECK: string = "vck";
    public static S2C_TEST_CASE_INFO: string = "core_tci";
    public static S2C_GET_PLAYER_INFO: string = "core_gpi";

    public static S2C_GENERATE_INVITE_CODE: string = "core_gic";
    public static S2C_SET_INVITE_CODE: string = "core_sic";

    // commands sent to server
    public static C2S_LOGIN: string = "lgn";
    public static C2S_LOGIN_SOCIAL: string = "lgs";
    public static C2S_NEW_LOGIN_SOCIAL: string = "core_spl";
    public static C2S_REGISTER: string = "lre";
    public static C2S_VERSION_CHECK: string = "vck";

    public static C2S_INVITE_FRIEND: string = "cif";
    public static C2S_NEW_CASH_HASH: string = "nch";

    public static C2S_REPORT_USER_SURVEY: string = "core_rus";

    public static C2S_REPORT_SURVEY: string = "rsv";

    public static C2S_VERIFY_PLAYER_MAIL_EVENT: string = "vpm";
    public static C2S_LOST_PASSWORD_EVENT: string = "lpp";

    public static C2S_SOCIAL_PLAYER_EXISTS: string = "core_spe";
    public static C2S_TEST_CASE_INFO: string = "core_tci";

    public static C2S_GENERATE_INVITE_CODE: string = "core_gic";
    public static C2S_SET_INVITE_CODE: string = "core_sic";
}

